//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Features/Features.SelectFeature.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[0,"AllowExtension",1,0],[0,"BoundaryCurve",1,"ScCollector",0],[0,"BoundaryFace",1,"ScCollector",0],[0,"BoundaryFilter",1,0],[0,"CurveColor",1,0],[0,"CurveLayer",1,0],[0,"Driver",1,0],[0,"EnableValidationChecker",1,0],[0,"ExtensionLength",1,1],[1,"ExtensionLengthExp",0,"Expression",0],[0,"EyeFeature",1,"Features.Feature",0],[0,"EyeRotateAngleDown",1,1],[1,"EyeRotateAngleDownExp",0,"Expression",0],[0,"EyeRotateAngleLeft",1,1],[1,"EyeRotateAngleLeftExp",0,"Expression",0],[0,"EyeRotateAngleRight",1,1],[1,"EyeRotateAngleRightExp",0,"Expression",0],[0,"EyeRotateAngleUp",1,1],[1,"EyeRotateAngleUpExp",0,"Expression",0],[0,"EyeRotationType",1,0],[1,"Eyellipse",0,"Features.SelectFeature",0],[0,"EyellipsePercentile",1,0],[0,"FaceColor",1,0],[0,"FaceLayer",1,0],[0,"GenerateLogFile",1,0],[0,"HeadTurnAngleLeft",1,1],[1,"HeadTurnAngleLeftExp",0,"Expression",0],[0,"HeadTurnAngleRight",1,1],[1,"HeadTurnAngleRightExp",0,"Expression",0],[0,"HeadTurnType",1,0],[0,"LeftEye",1,"Point",0],[0,"LimitationType",1,0],[0,"Loading",1,0],[0,"OutputBoundaryCurves",1,0],[0,"OutputVisionFace",1,0],[0,"RightEye",1,"Point",0],[0,"UseStandardLoading",1,0],[0,"ViewResults",1,0]],[[[],"ValidationButton",{},0,0]],[]];
SPLM.Features.VehicleDesign.DirectFieldViewBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.DirectFieldViewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.DirectFieldViewBuilder.DriverType = Object.freeze({
    "AGroupofDrivers" : "AGroupofDrivers", "AnIndividualDriver" : "AnIndividualDriver"});

SPLM.Features.VehicleDesign.DirectFieldViewBuilder.EyePercentile = Object.freeze({
    "Per95" : "Per95", "Per99" : "Per99"});

SPLM.Features.VehicleDesign.DirectFieldViewBuilder.LimitType = Object.freeze({
    "ByanApertureThroughAWindow" : "ByanApertureThroughAWindow", "ByHeadTurnandEyeRotation" : "ByHeadTurnandEyeRotation"});

SPLM.Features.VehicleDesign.DirectFieldViewBuilder.BoundaryFilterType = Object.freeze({
    "CurvesEdges" : "CurvesEdges", "Faces" : "Faces"});

SPLM.Features.VehicleDesign.DirectFieldViewBuilder.EyeRotation = Object.freeze({
    "Maximum" : "Maximum", "Easy" : "Easy", "Customize" : "Customize"});

SPLM.Features.VehicleDesign.DirectFieldViewBuilder.HeadTurn = Object.freeze({
    "Maximum" : "Maximum", "Easy" : "Easy", "Customize" : "Customize", "No" : "No"});

export default SPLM;